import { influencerQueries } from '@round/api';
import { QueryClient, useQueryClient } from '@tanstack/react-query';

const options = influencerQueries.location.options.detail;

async function getLocations(queryClient: QueryClient, ids: number[]) {
    const results = await Promise.allSettled(ids.map((id) => queryClient.fetchQuery(options(id))));
    return results.flatMap((result) => (result.status === 'fulfilled' ? result.value : []));
}

export function useFetchInfluencerLocations() {
    const queryClient = useQueryClient();
    return (ids: number[]) => getLocations(queryClient, ids);
}
